import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OverlayModule } from '@angular/cdk/overlay';

import { IconsModule } from '../../design/icons.module';
import { ActionMenuComponent } from './action-menu.component';
import { RowActionsMenuComponent } from '../row-actions-menu/row-actions-menu.component';

@NgModule({
  declarations: [ActionMenuComponent, RowActionsMenuComponent],
  imports: [CommonModule, IconsModule, OverlayModule],
  exports: [ActionMenuComponent, RowActionsMenuComponent]
})
export class ActionMenuModule { }
